import EventManager from "./EventManager";

export function eventSubscriber<T extends { new (...args: any[]): {} }>(
  constructor: T
) {
  return class extends constructor {

    constructor(...args : any[]) {
      super(...args);
      if (typeof this.subscribe === 'function') this.subscribe()
    }

    subscribe: Function

    subscribedTo: { [eventName: string]: Array<Function> }

    unsubscribe () {
      for (const eventName in this.subscribedTo) {
        this.subscribedTo[eventName].forEach( cb => {
          EventManager.off(eventName, cb)
        })
      }
    }
  };
}

export function emit(eventName: string) {
  return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
    const originalMethod = descriptor.value;
    descriptor.value = function (...args: any[]) {
      EventManager.emit(eventName, ...args);
      return originalMethod.apply(this, args);
    }

    return descriptor;
  }
}

export function on(eventName: string) {
  return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
    const oldSubscribe = target.subscribe
    target.subscribe = function () {
      if (typeof oldSubscribe === 'function') oldSubscribe.apply(this)
      const fun = this[propertyKey].bind(this)
      if (typeof this.subscribedTo === 'undefined') this.subscribedTo = {}
      if (typeof this.subscribedTo[eventName] === 'undefined') this.subscribedTo[eventName] = []
      this.subscribedTo[eventName].push(fun)
      EventManager.on(eventName, fun);
    }
  }
}

export function observe(target: any, propertyKey: string, descriptor?: PropertyDescriptor): any {
  let store = target[propertyKey]
  descriptor = {
    get (): any {
      return store
    },
    set (value) {
      store = value
      EventManager.emit(propertyKey+'-changed', value)
    }
  }
  return descriptor
}
